// eslint-disable-next-line no-unused-vars
class Subscription extends Core {
	constructor(component) {
		super();
		this.component = component;
		this.type = component.getAttribute("data-type");
		this.currentStep = 0;
		this.totalSteps = 0;
		this.stepsTaken = 0;
		this.frequency = null;
		this.duration = null;
		this.deliveryDay = null;
		this.productType = null;
		this.giftPayload = {
			site: this.siteCode,
			items: [],
		};
		this.personalPayload = {
			site: this.siteCode,
			items: [],
		};
		this.subsData = JSON.parse(this.component.querySelector("script").text);
		this.progressRangeEl = this.component.querySelector(".subs-progress-range > div");
		this.progressBarStepsEl = Array.from(this.component.querySelectorAll(".subs-progress-step"));
		this.stepPanels = Array.from(this.component.querySelectorAll(".subs-steps-holder > .subs-step-panel"));
		this.progressCarouselImgsEl = Array.from(this.component.querySelectorAll(".subs-carousel > div"));
		this.unitPricesEl = Array.from(this.component.querySelectorAll("[data-subs-unit-price]"));
		this.compareAtPricesEl = Array.from(this.component.querySelectorAll("[data-subs-compare-at-price]"));

		this.reviewProduct = this.component.querySelector(".review-product");
		this.reviewFrequency = this.component.querySelector(".review-frequency");
		this.reviewDuration = this.component.querySelector(".review-duration"); // gift
		this.reviewDeliveryDay = this.component.querySelector(".review-delivery-day"); // personal
		this.reviewSubsPrice = this.component.querySelector(".subs-price");
		this.reviewPDFLink = this.component.querySelector(".subs-pdf-link > a"); // gift

		this.cardEditor = null;
		this.cardPreviewNoCard = this.component.querySelector(".subs-card.no-card");
		this.cardPreviewHolder = this.component.querySelector(".subs-card.card-selected");
		this.cardPreviewImg = this.component.querySelector("#subs-image-preview");
		this.cardpreviewMsg = this.component.querySelector("#subs-message-preview");
		this.cardSelectBtn = this.component.querySelector("#subs-card-select");
		this.cardContinueBtn = this.component.querySelector("#subs-card-continue");
		this.noCardOption = false;

		this.btnNext = this.component.querySelector("button.next");
		this.btnPrev = this.component.querySelector("button.prev");

		this.component.addEventListener("click", this.handleEvents.bind(this));
		this.initComponent();
	}

	isProductPredefined() {
		try {
			const premiumQueryParam = getUrlParam("premium");
			const ethicalQueryParam = getUrlParam("ethical");
			const petFriendlyQueryParam = getUrlParam("pet_friendly");

			let PremiumOrEthicalOrPet = null;
			if (premiumQueryParam === "true") {
				PremiumOrEthicalOrPet = "premium";
			} else if (ethicalQueryParam === "true") {
				PremiumOrEthicalOrPet = "ethical";
			} else if (petFriendlyQueryParam === "true") {
				PremiumOrEthicalOrPet = "petFriendly";
			}
			if (!PremiumOrEthicalOrPet) return;

			if (PremiumOrEthicalOrPet) {
				const productPanelIndex = this.stepPanels.findIndex((panel) => panel.getAttribute("data-id") === "product");
				if (productPanelIndex >= 0) {
					this.totalSteps -= 1;
					this.productType = PremiumOrEthicalOrPet;
					this.stepPanels[productPanelIndex].remove();
					this.progressBarStepsEl[productPanelIndex].remove();
					this.stepPanels.splice(productPanelIndex, 1);
					this.progressBarStepsEl.splice(productPanelIndex, 1);
					if (this.progressCarouselImgsEl[productPanelIndex]) {
						this.progressCarouselImgsEl[productPanelIndex].remove();
						this.progressCarouselImgsEl.splice(productPanelIndex, 1);
					}
				}
			}
		} catch (error) {
			// do nothing
		}
	}

	async initComponent() {
		this.totalSteps = this.stepPanels.length;

		// Initialize panels
		this.stepPanels.forEach((panel) => {
			panel.setAttribute("style", `transform: translateX(0%); visibility: hidden;`);
		});
		this.stepPanels[0].setAttribute("style", `transform: translateX(0%); visibility: visible;`);

		// check if the variant has already been defined and remove the panel if so
		this.isProductPredefined();

		this.btnPrev.setAttribute("disabled", true);
		this.btnNext.setAttribute("disabled", true);

		if (this.type === "gift") {
			const quillCssCdnHref = "https://cdn.quilljs.com/1.3.6/quill.snow.css";
			const quillCss = document.createElement("link");
			quillCss.setAttribute("rel", "stylesheet");
			quillCss.setAttribute("type", "text/css");
			quillCss.setAttribute("href", quillCssCdnHref);
			document.head.appendChild(quillCss);
			const quillJsCdnSrc = "https://cdn.quilljs.com/1.3.6/quill.js";
			const quillJs = document.createElement("script");
			quillJs.src = quillJsCdnSrc;
			document.body.appendChild(quillJs);
			await new Promise((resolve, reject) => {
				quillJs.addEventListener("load", resolve);
				quillJs.addEventListener("error", (error) => reject(error));
			});
			// Load and initialize card selector
			addScript("/assets/js/card-editor.js", async () => {
				this.cardEditor = new CardEditor({
					title: "Add a free gift card",
					saveBtnLabel: "Save",
					onError: (err) => {
						log(err);
						if (typeof Rollbar === "object") {
							Rollbar.error(err.message, err);
						}
					},
					onSelect: (data) => {
						if (!this.giftPayload.cardId || this.noCardOption) this.stepsTaken += 1;
						if (data.noCard) {
							this.cardPreviewHolder.classList.add("hide");
							this.cardPreviewNoCard.classList.remove("hide");
							this.noCardOption = true;
						} else {
							this.giftPayload.items.push({
								merchandiseId: data.cardId,
								quantity: 1,
								...(!data.leaveBlank && {
									attributes: [
										{ key: "_cardHeader", value: data.cardHeader },
										{ key: "_cardBody", value: data.cardBody },
										{ key: "_cardFooter", value: data.cardFooter },
										{ key: "_cardContent", value: data.cardTextContent },
									],
								}),
							});
							this.cardPreviewHolder.classList.remove("hide");
							this.cardPreviewNoCard.classList.add("hide");
							this.noCardOption = false;
						}
						this.cardSelectBtn.textContent = "Change card";
						this.cardContinueBtn.removeAttribute("disabled");
					},
				});
				addStyle("/assets/css/card-editor.css");
				await this.cardEditor.createEditor();
			});
		}
		this.component.style.opacity = 1;
	}

	selectOption(option) {
		const options = this.stepPanels[this.currentStep].querySelectorAll("button");
		Array.from(options).forEach((btn) => btn.classList.remove("selected"));
		option.classList.add("selected");
	}

	updatePrices(priceEles, priceKey) {
		if (!this.frequency) return;

		priceEles.forEach((priceEle) => {
			const duration = parseInt(priceEle.getAttribute("data-duration"), 10);
			const product = this.subsData.options[this.frequency][duration];
			const variantIndex = this.getVariantIndex();
			const selectedVariant = product.variants[variantIndex];
			const totalPrice = parseFloat(selectedVariant[priceKey]);
			if (totalPrice === 0) return;
			const numDeliveries = Math.floor(((52 / 12) * duration) / parseInt(this.frequency, 10));
			const pricePerDelivery = totalPrice / numDeliveries;
			// eslint-disable-next-line no-param-reassign
			priceEle.textContent = currencyFormat(pricePerDelivery);
		});
	}

	updateSummary() {
		if (!this.frequency || !this.productType || !(this.duration || this.deliveryDay)) return;
		const { price, variant } = this.getSelectedOption();

		this.reviewFrequency.textContent = `${this.frequency} week${this.frequency > 1 ? "s" : ""}`;
		this.reviewSubsPrice.textContent = currencyFormat(price);
		let reviewProductTextContent = "ethical";
		if (this.productType === "petFriendly") {
			reviewProductTextContent = "pet friendly";
		} else if (this.productType === "premium") {
			reviewProductTextContent = "luxury";
		}
		this.reviewProduct.textContent = reviewProductTextContent;
		if (this.type === "gift") {
			this.reviewDuration.textContent = `${this.duration} months`;
			this.reviewPDFLink.href = variant.pdf;
		} else {
			this.reviewDeliveryDay.textContent = this.deliveryDay;
		}
	}

	setFrequency(frequency, target) {
		if (!this.frequency) this.stepsTaken += 1;
		this.frequency = frequency;
		this.selectOption(target);
		setTimeout(() => {
			this.nextStep();
		}, 500);
	}

	setDuration(duration, target) {
		if (!this.duration) this.stepsTaken += 1;
		this.duration = duration;
		this.selectOption(target);
		setTimeout(() => this.nextStep(), 500);
	}

	setProductType(productType, target) {
		if (!this.productType) this.stepsTaken += 1;
		this.productType = productType;
		this.selectOption(target);
		setTimeout(() => this.nextStep(), 500);
	}

	setDeliveryDay(day, target) {
		if (!this.deliveryDay) this.stepsTaken += 1;
		this.deliveryDay = day;
		this.selectOption(target);
		setTimeout(() => this.nextStep(), 500);
	}

	getVariantIndex() {
		let variantIndex = 0;
		if (this.productType === "petFriendly") {
			variantIndex = 1;
		} else if (this.productType === "premium") {
			variantIndex = 2;
		}
		return variantIndex;
	}

	getSelectedOption() {
		if (this.type === "gift") {
			const productSelected = this.subsData.options[this.frequency][this.duration];
			const variantIndex = this.getVariantIndex();
			return {
				handle: productSelected.handle,
				price: productSelected.variants[variantIndex].price,
				variant: productSelected.variants[variantIndex],
			};
		}

		const productSelected = this.subsData.options[this.productType];
		return {
			handle: productSelected.handle,
			price: productSelected.price,
			variant: productSelected,
		};
	}

	nextStep() {
		if (this.currentStep <= this.stepsTaken - 1 && this.currentStep < this.totalSteps - 1) {
			this.currentStep += 1;

			// Updates progress bar
			this.progressBarStepsEl.forEach((step) => {
				step.classList.remove("current");
			});
			this.progressRangeEl.style.width = `${(100 / (this.totalSteps - 1)) * this.stepsTaken}%`;
			this.progressBarStepsEl[this.currentStep - 1].classList.add("filled");
			this.progressBarStepsEl[this.currentStep].classList.add("current");

			// Move panels
			this.stepPanels.forEach((panel) => {
				panel.setAttribute("style", `transform: translateX(${this.currentStep * -100}%); visibility: hidden;`);
			});
			this.stepPanels[this.currentStep].style.visibility = "visible";

			// Manage focus, wait 500 ms to finish the transition
			const firstIntoViewButton = this.stepPanels[this.currentStep].querySelector("button");
			if (firstIntoViewButton) setTimeout(() => firstIntoViewButton.focus(), 500);

			// Revels next carousel image if exists
			if (this.progressCarouselImgsEl[this.currentStep]) {
				this.progressCarouselImgsEl[this.currentStep].style.opacity = 1;
			}

			if (this.currentStep !== 0) this.btnPrev.removeAttribute("disabled");
			if (this.currentStep >= this.stepsTaken || this.currentStep === this.totalSteps - 1)
				this.btnNext.setAttribute("disabled", true);

			// update panels
			this.updatePrices(this.unitPricesEl, "price");
			this.updatePrices(this.compareAtPricesEl, "compareAtPrice");
			this.updateSummary();
		}
	}

	prevStep() {
		if (this.currentStep > 0) {
			this.currentStep -= 1;

			// Updates progress bar
			this.progressBarStepsEl.forEach((step) => {
				step.classList.remove("current");
			});
			this.progressBarStepsEl[this.currentStep].classList.add("current");

			// Move panels
			this.stepPanels.forEach((panel) => {
				panel.setAttribute("style", `transform: translateX(${this.currentStep * -100}%); visibility: hidden;`);
			});
			this.stepPanels[this.currentStep].style.visibility = "visible";

			// Manage focus wait 500 ms to finish the transition
			const firstIntoViewButton = this.stepPanels[this.currentStep].querySelector("button");
			if (firstIntoViewButton) setTimeout(() => firstIntoViewButton.focus(), 500);

			// Makes the previous carousel image opaque, if it exists
			if (this.progressCarouselImgsEl[this.currentStep + 1]) {
				this.progressCarouselImgsEl[this.currentStep + 1].style.opacity = 0.2;
			}

			if (this.currentStep === 0) this.btnPrev.setAttribute("disabled", true);
			if (this.currentStep < this.totalSteps) this.btnNext.removeAttribute("disabled");
		}
	}

	showPetModal() {
		if (!this.subsData.info || !this.subsData.info.petDetails) return;
		showModal({
			txtHeader: this.subsData.info.petDetails.title,
			txtBody: this.subsData.info.petDetails.body,
		});
	}

	// Sends event to POQ when into webview
	sendPoqEvt() {
		if (typeof PoqWebCheckout !== "object") return;

		const optionSelected = this.getSelectedOption();
		const payload = {
			product: {
				externalProductId: optionSelected.variant.variantId.replace("gid://shopify/ProductVariant/", ""),
				productTitle: optionSelected.handle,
			},
		};
		PoqWebCheckout.send("viewPdp", payload);
	}

	async submitGift() {
		if (!this.frequency || !this.duration || !this.productType) return;
		this.clearCheckout(); // When making gift subscription needs clear old checkouts

		const optionSelected = this.getSelectedOption();

		this.giftPayload.items.push({
			merchandiseId: optionSelected.variant.variantId,
			quantity: 1,
		});

		this.htmlEl.loading.classList.remove("hide");
		const addItemResult = await this.addItemsCart(this.giftPayload);
		if (addItemResult.result) {
			const isValidCheckout = this.checkCheckoutValid();

			if (isValidCheckout.valid) {
				// When making a gift subscription into webview, use session instead cookies
				// workaround to deal with issue to override cookies into POQ app webview.
				if (window.isPoqMode) {
					sessionStorage.setItem("checkoutId", this.checkoutId);
					this.sendPoqEvt();
				}
				// &skip_shop_pay=true -> It's an unofficial solution to avoid the default use of shop pay at checkout.
				window.location = `${this.checkoutObj.checkoutUrl}&skip_shop_pay=true`;
			} else {
				window.location = "/cart/";
			}
		} else if (addItemResult.error) {
			showModal({
				txtHeader: "PROBLEM WITH BASKET!",
				htmlBody: this.apiErrorMessage(addItemResult.error),
			});
		} else {
			showModal(this.unexpectedError);
		}
		this.htmlEl.loading.classList.add("hide");
	}

	async submitPersonal() {
		if (!this.frequency || !this.deliveryDay || !this.productType) return;

		const optionSelected = this.getSelectedOption();
		const sellingPlan = optionSelected.variant.sellingPlans?.find((plan) => plan.frequency === this.frequency);
		if (!sellingPlan) throw Error(`Subscription product ${optionSelected.handle} does not have a selling plan.`);

		this.personalPayload.items = []; // clean

		this.personalPayload.items.push({
			merchandiseId: optionSelected.variant.variantId,
			sellingPlanId: sellingPlan.sellingPlanId,
			quantity: 1,
			attributes: [
				{ key: "_delivery_day", value: this.deliveryDay },
				{ key: "_shipping_interval_frequency", value: this.frequency },
				{ key: "_shipping_interval_unit_type", value: "week" },
			],
		});

		this.htmlEl.loading.classList.remove("hide");

		const addItemResult = await this.addItemsCart(this.personalPayload);
		if (addItemResult.result) {
			if (window.isPoqMode) this.sendPoqEvt();
			// &skip_shop_pay=true -> It's an unofficial solution to avoid the default use of shop pay at checkout.
			window.location = `${this.checkoutObj.checkoutUrl}&skip_shop_pay=true`;
		} else if (addItemResult.error) {
			showModal({
				txtHeader: "PROBLEM WITH BASKET!",
				htmlBody: this.apiErrorMessage(addItemResult.error),
			});
		} else {
			showModal(this.unexpectedError);
		}

		this.htmlEl.loading.classList.add("hide");
	}

	handleEvents(e) {
		const id = e.target.getAttribute("data-id");
		switch (id) {
			case "subscription-frequency":
				this.setFrequency(e.target.getAttribute("data-value"), e.target);
				break;
			case "subscription-duration":
				this.setDuration(e.target.getAttribute("data-value"), e.target);
				break;
			case "subscription-delivery-day":
				this.setDeliveryDay(e.target.getAttribute("data-value"), e.target);
				break;
			case "subscription-product":
				this.setProductType(e.target.getAttribute("data-value"), e.target);
				break;
			case "pet-details-modal":
				this.showPetModal();
				break;
			case "subs-card-open":
				this.cardEditor.openSelector();
				break;
			case "subs-btn-checkout":
				if (this.type === "gift") {
					this.submitGift();
				} else {
					this.submitPersonal();
				}
				break;
			case "prev-step":
				this.prevStep();
				break;
			case "next-step":
				this.nextStep();
				break;
			default:
			// nothing to do
		}
	}
}
